import { AfterViewInit, Component, inject, Inject, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, UpperCasePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { fpModalDirective, ModalRef, ModalService, ModalType } from '@flitpay-internal/modal';
import { DatapassService } from '../../_services/datapass.service';
import { SwUpdate } from '@angular/service-worker';

export type askUpdateModalItemType = {
	isOpen: boolean;
}

@Component({
	selector: 'fpl-ask-update-modal',
	imports: [fpModalDirective, UpperCasePipe],
	templateUrl: './ask-update.component.html',
	styleUrl: './ask-update.component.scss'
})
export class AskUpdateComponent implements AfterViewInit, OnDestroy {
	@ViewChild('askUpdate') askUpdateModal!: fpModalDirective;
	// modal variables
	modalId: string | null = null; modalItem: askUpdateModalItemType | null = null;
	modalSub: Subscription | null = null;

	private swUpdate = inject(SwUpdate);

	constructor(
		private datapassService: DatapassService,
		private modalService: ModalService,
		@Inject(PLATFORM_ID) public platformId: Object,
		@Inject(DOCUMENT) private document: Document,
	) { }

	ngAfterViewInit(): void {
		this.modalSub = this.datapassService.askUpdateModal$.subscribe((item: askUpdateModalItemType | null) => {
			this.modalItem = item ?? null;
			if (this.modalItem) {
				this.open(this.modalItem);
			}
		});
	}

	// open modal
	open(item: askUpdateModalItemType) {
		if (item?.isOpen) {
			const modalRef: ModalRef = this.askUpdateModal.open({ size: ModalType?.medium });
			this.modalId = modalRef?.id ?? null;
		}
	}

	handleUpdateClick() {
		if (isPlatformBrowser(this.platformId)) {
			// this.modalService.closeAllModals();
			this.swUpdate.activateUpdate().then(() => this.document.location.reload());
		}
	}

	// reset modal
	resetModal() {
		this.modalItem = null;
		if (this.modalId) {
			this.modalService.closeModal(this.modalId);
			this.modalId = null;
		}
	}

	ngOnDestroy(): void {
		if (this.modalSub) {
			this.modalSub.unsubscribe();
		}
	}

}
